import React from 'react';

export default (props) => <span className="tag" style={{padding:'calc(.6vw + 16px)',margin:'calc(.5vw + 2px)',backgroundColor:'transparent', color:'transparent',boxShadow: '0 3px 6px rgba(0,0,0,0.15)'}}>
  <p className="has-text-weight-light" style={{fontSize:'calc(.6vw + 16px)'}}>
  {props.children}
  </p>
</span>;